





































































































































































































































import Vue from 'vue'
import { PlayerGameStatus, Connection } from '../types'

export default Vue.extend({
  name: 'MyCards',
  props: [
    'status',
    'connections',
    'top',
    'flop',
    'job',
    'myBoss',
    'myApplication',
    'showEducationAction',
    'educationActionsLeft',
    'showInitiativeApplicationAction',
    'initiativeApplicationActionsLeft',
    'myInitiativeBoss',
    'me',
  ],
  data: function() {
    return {
      theplayerGameStatus: PlayerGameStatus,
    }
  },
  computed: {
    jobCardClickable: function(): boolean {
      return (
        this.status == PlayerGameStatus.selectAJobAsBoss ||
        this.status == PlayerGameStatus.createApplication ||
        this.status == PlayerGameStatus.createInitiativeApplication
      )
    },
    topOrFlopCardClickable: function(): boolean {
      return (
        this.status == PlayerGameStatus.createApplication ||
        this.status == PlayerGameStatus.createInitiativeApplication
      )
    },
  },
  methods: {
    educationActionClicked: function() {
      this.$emit('education-action-clicked')
    },
    inititativeApplicationActionClicked: function() {
      this.$emit('initiative-application-action-clicked')
    },
  },
})
